import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-484bd1ab"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "modais" }
const _hoisted_2 = {
  class: "modal fade",
  id: "EditaVeiculo",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalCenterTitle",
  "aria-hidden": "true"
}
const _hoisted_3 = {
  class: "modal-dialog modal-dialog-centered modal-lg",
  role: "document"
}
const _hoisted_4 = {
  style: {"border-radius":"10px"},
  class: "modal-content"
}
const _hoisted_5 = { class: "modal-header p-5" }
const _hoisted_6 = { class: "d-flex gap-4 p-0 align-items-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"background":"rgb(236, 236, 236)"},
  class: "p-3 rounded"
}, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"height":"fit-content","width":"fit-content","font-size":"18px","color":"#203972 !important"},
    class: "m-0 fas fa-pencil-alt"
  })
], -1))
const _hoisted_8 = { class: "m-0 subtitulo cor_texto_1" }
const _hoisted_9 = {
  style: {"font-size":"11px"},
  class: "m-0 legenda text-muted"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  height: "2em",
  fill: "#afb7bd",
  widxmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 320 512"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z" })
], -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  class: "modal-body d-flex flex-column p-5 background_2 gap-5",
  id: "modalBody"
}
const _hoisted_13 = {
  style: {"border-radius":"10px"},
  class: "d-flex overflow-hidden w-100 background_1"
}
const _hoisted_14 = {
  style: {"background":"#efefef"},
  class: "px-8 py-5 d-flex justify-content-center align-items-center"
}
const _hoisted_15 = { class: "w-100 d-flex justify-content-between align-items-center p-5" }
const _hoisted_16 = {
  key: 0,
  class: "m-0 texto bold cor_texto_1"
}
const _hoisted_17 = {
  key: 1,
  class: "m-0 texto bold cor_texto_1"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  style: {"height":"fit-content","width":"fit-content","font-size":"18px"},
  class: "m-0 fas fa-info"
}, null, -1))
const _hoisted_19 = {
  style: {"border-radius":"10px"},
  class: "d-flex flex-column overflow-hidden p-5 w-100 background_1 gap-3"
}
const _hoisted_20 = { class: "w-100" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 texto bold cor_texto_1" }, "Filtros", -1))
const _hoisted_22 = { class: "d-flex gap-3" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Oleo ", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Ar", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Ar Condicionado", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Combustível", -1))
const _hoisted_27 = {
  style: {"background":"#efefef","border-radius":"8px"},
  class: "p-4 d-flex flex-column gap-3"
}
const _hoisted_28 = {
  key: 0,
  class: "d-flex align-items-center w-100"
}
const _hoisted_29 = {
  key: 0,
  class: "d-flex align-items-center w-100 mx-1"
}
const _hoisted_30 = {
  class: "me-1 texto",
  style: {"width":"30%","border":"1.5px solid rgb(219, 219, 219)","border-radius":"4px","background-color":"#ffffff","padding-left":"15px","line-height":"38px"}
}
const _hoisted_31 = {
  class: "ms-1 texto",
  style: {"width":"100%","border":"1.5px solid rgb(219, 219, 219)","border-radius":"4px","background-color":"#ffffff","padding-left":"15px","line-height":"38px"}
}
const _hoisted_32 = {
  key: 1,
  class: "d-flex align-items-center w-100 mx-1"
}
const _hoisted_33 = { class: "texto" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  fill: "white",
  width: "25",
  height: "25",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 640"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M100.4 417.2C104.5 402.6 112.2 389.3 123 378.5L304.2 197.3L338.1 163.4C354.7 180 389.4 214.7 442.1 267.4L476 301.3L442.1 335.2L260.9 516.4C250.2 527.1 236.8 534.9 222.2 539L94.4 574.6C86.1 576.9 77.1 574.6 71 568.4C64.9 562.2 62.6 553.3 64.9 545L100.4 417.2zM156 413.5C151.6 418.2 148.4 423.9 146.7 430.1L122.6 517L209.5 492.9C215.9 491.1 221.7 487.8 226.5 483.2L155.9 413.5zM510 267.4C493.4 250.8 458.7 216.1 406 163.4L372 129.5C398.5 103 413.4 88.1 416.9 84.6C430.4 71 448.8 63.4 468 63.4C487.2 63.4 505.6 71 519.1 84.6L554.8 120.3C568.4 133.9 576 152.3 576 171.4C576 190.5 568.4 209 554.8 222.5C551.3 226 536.4 240.9 509.9 267.4z" })
], -1))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  fill: "white",
  width: "25",
  height: "25",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 640"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M88 256L232 256C241.7 256 250.5 250.2 254.2 241.2C257.9 232.2 255.9 221.9 249 215L202.3 168.3C277.6 109.7 386.6 115 455.8 184.2C530.8 259.2 530.8 380.7 455.8 455.7C380.8 530.7 259.3 530.7 184.3 455.7C174.1 445.5 165.3 434.4 157.9 422.7C148.4 407.8 128.6 403.4 113.7 412.9C98.8 422.4 94.4 442.2 103.9 457.1C113.7 472.7 125.4 487.5 139 501C239 601 401 601 501 501C601 401 601 239 501 139C406.8 44.7 257.3 39.3 156.7 122.8L105 71C98.1 64.2 87.8 62.1 78.8 65.8C69.8 69.5 64 78.3 64 88L64 232C64 245.3 74.7 256 88 256z" })
], -1))
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  fill: "white",
  width: "25",
  height: "25",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 384 512"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" })
], -1))
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  style: {"height":"fit-content","width":"fit-content","font-size":"18px"},
  class: "m-0 fas fa-plus"
}, null, -1))
const _hoisted_44 = { class: "modal-footer p-5 d-flex justify-content-start align-items-center gap-3" }
const _hoisted_45 = {
  key: 0,
  style: {"width":"fit-content","height":"fit-content"},
  class: "d-flex m-0 p-0 text-justify text-danger"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  fill: "white",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M448 384H256c-35.3 0-64-28.7-64-64V64c0-35.3 28.7-64 64-64H396.1c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9V320c0 35.3-28.7 64-64 64zM64 128h96v48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H256c8.8 0 16-7.2 16-16V416h48v32c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64z" })
], -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  fill: "white",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M160 0c-23.7 0-44.4 12.9-55.4 32H48C21.5 32 0 53.5 0 80V400c0 26.5 21.5 48 48 48H192V176c0-44.2 35.8-80 80-80h48V80c0-26.5-21.5-48-48-48H215.4C204.4 12.9 183.7 0 160 0zM272 128c-26.5 0-48 21.5-48 48V448v16c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V243.9c0-12.7-5.1-24.9-14.1-33.9l-67.9-67.9c-9-9-21.2-14.1-33.9-14.1H320 272zM160 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48z" })
], -1))
const _hoisted_48 = {
  key: 0,
  style: {"font-size":"medium","height":"18px","width":"18px"},
  class: "spinner-border",
  role: "status"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1))
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = {
  key: 1,
  width: "20",
  height: "20",
  fill: "white",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V173.3c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32H64zm0 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM224 416c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64z" }, null, -1))
const _hoisted_53 = [
  _hoisted_52
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_modal_info_veiculo = _resolveComponent("modal-info-veiculo")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_8, _toDisplayString(`${_ctx.veiculos.length === 1 ? 'Editar veículo' : 'Editar veículos'}`), 1),
                  _createElementVNode("p", _hoisted_9, _toDisplayString(`${_ctx.veiculos.length === 1 ? 'Veja e altere as informações do veículo' : 'Veja e altere as informações dos veículos'}`), 1)
                ])
              ]),
              _createElementVNode("div", {
                class: "cursor-pointer",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (!_ctx.loadingSalva && _ctx.dismiss())),
                "aria-label": "Close"
              }, _hoisted_11)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("section", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_inline_svg, {
                    src: "media\\icons\\duotune\\general\\car.svg",
                    style: {"width":"22px","height":"22px"}
                  })
                ]),
                _createElementVNode("div", _hoisted_15, [
                  (_ctx.veiculos.length === 1)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(`${_ctx.veiculos[0]?.modelo} ${_ctx.veiculos[0]?.ano2}`), 1))
                    : (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(`${_ctx.veiculos.length} veículos selecionados`), 1)),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openModal('infoVeiculo'))),
                    class: "btn btn-light-danger d-flex d-inline-block text-truncate flex-row justify-content-center align-items-center px-4 py-0 gap-4 texto",
                    style: {"height":"40px"}
                  }, [
                    _hoisted_18,
                    _createTextVNode(" Informações ")
                  ])
                ])
              ]),
              _createElementVNode("section", _hoisted_19, [
                _createElementVNode("section", _hoisted_20, [
                  _hoisted_21,
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", {
                      type: "button",
                      onClick: _cache[2] || (_cache[2] = ()=> _ctx.tipoSelecionado = 'filtro_oleo'),
                      style: _normalizeStyle([{"height":"fit-content","white-space":"nowrap"}, `opacity: ${ _ctx.tipoSelecionado == 'filtro_oleo' ? 1 : 0.3}`]),
                      class: "btn btn-danger d-flex flex-row w-100 gap-3 px-5 py-3 justify-content-center align-items-center texto"
                    }, [
                      _hoisted_23,
                      _createElementVNode("div", null, _toDisplayString(_ctx.produtoVeiculo.filter((e)=> e.tipo == 'filtro_oleo').length), 1)
                    ], 4),
                    _createElementVNode("div", {
                      type: "button",
                      onClick: _cache[3] || (_cache[3] = ()=> _ctx.tipoSelecionado = 'filtro_ar'),
                      style: _normalizeStyle([{"height":"fit-content","white-space":"nowrap"}, `opacity: ${ _ctx.tipoSelecionado == 'filtro_ar' ? 1 : 0.3}`]),
                      class: "btn btn-danger d-flex flex-row w-100 gap-3 px-5 py-3 justify-content-center align-items-center texto"
                    }, [
                      _hoisted_24,
                      _createElementVNode("div", null, _toDisplayString(_ctx.produtoVeiculo.filter((e)=> e.tipo == 'filtro_ar').length), 1)
                    ], 4),
                    _createElementVNode("div", {
                      type: "button",
                      onClick: _cache[4] || (_cache[4] = ()=> _ctx.tipoSelecionado = 'filtro_ac'),
                      style: _normalizeStyle([{"height":"fit-content","white-space":"nowrap"}, `opacity: ${ _ctx.tipoSelecionado == 'filtro_ac' ? 1 : 0.3}`]),
                      class: "btn btn-danger d-flex flex-row w-100 gap-3 px-5 py-3 justify-content-center align-items-center texto"
                    }, [
                      _hoisted_25,
                      _createElementVNode("div", null, _toDisplayString(_ctx.produtoVeiculo.filter((e)=> e.tipo == 'filtro_ac').length), 1)
                    ], 4),
                    _createElementVNode("div", {
                      type: "button",
                      onClick: _cache[5] || (_cache[5] = ()=> _ctx.tipoSelecionado = 'filtro_combustivel'),
                      style: _normalizeStyle([{"height":"fit-content","white-space":"nowrap"}, `opacity: ${ _ctx.tipoSelecionado == 'filtro_combustivel' ? 1 : 0.3}`]),
                      class: "btn btn-danger d-flex flex-row w-100 gap-3 px-5 py-3 justify-content-center align-items-center texto"
                    }, [
                      _hoisted_26,
                      _createElementVNode("div", null, _toDisplayString(_ctx.produtoVeiculo.filter((e)=> e.tipo == 'filtro_combustivel').length), 1)
                    ], 4)
                  ])
                ]),
                _createElementVNode("section", _hoisted_27, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produtoVeiculo, (produto, i) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                      (produto.tipo === _ctx.tipoSelecionado)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            (!produto.editando)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                  _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.produtoVeiculo[i].marca), 1),
                                  _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.produtoVeiculo[i].nome), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                  _createVNode(_component_el_select, {
                                    modelValue: _ctx.produtoVeiculo[i].idMarca,
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.produtoVeiculo[i].idMarca) = $event),
                                    "collapse-tags": "",
                                    placeholder: "Selecione uma marca",
                                    clearable: "",
                                    style: {"width":"30.5%","border-radius":"8px","color":"black"},
                                    class: "me-1",
                                    onChange: ($event: any) => {_ctx.buscarModelos(i); produto.marca = _ctx.arrayMarcas.find(m => m.id_marca_produto === produto.idMarca)?.nome}
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrayMarcas, (marca) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          label: marca.nome,
                                          value: marca.id_marca_produto
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("span", _hoisted_33, _toDisplayString(marca.nome), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["label", "value"]))
                                      }), 256))
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"]),
                                  _createVNode(_component_el_select, {
                                    modelValue: _ctx.produtoVeiculo[i].id_filtro,
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.produtoVeiculo[i].id_filtro) = $event),
                                    value: _ctx.produtoVeiculo[i].nome,
                                    placeholder: "Selecione o modelo",
                                    disabled: !_ctx.produtoVeiculo[i].idMarca || _ctx.carregandoModelos[i],
                                    loading: _ctx.carregandoModelos[i],
                                    "no-data-text": 'Sem filtros cadastrados',
                                    filterable: "",
                                    class: "ms-1 w-100",
                                    style: {"border-radius":"8px","color":"black"},
                                    onChange: ($event: any) => (produto.nome = _ctx.modelosPorLinha[i].find(m => m.id === produto.id_filtro)?.nome)
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.modelosPorLinha[i] || []), (mod) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: mod.id,
                                          label: mod.nome,
                                          value: mod.id
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "onUpdate:modelValue", "value", "disabled", "loading", "onChange"])
                                ])),
                            (!produto.editando)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 2,
                                  onClick: ($event: any) => (_ctx.editarProduto(i)),
                                  style: {"border-radius":"8px","width":"fit-content","height":"fit-content","cursor":"pointer"},
                                  class: "p-2 bg-danger me-1"
                                }, _hoisted_36, 8, _hoisted_34))
                              : _createCommentVNode("", true),
                            (produto.editando && !produto.adicionar)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 3,
                                  onClick: ($event: any) => (_ctx.fecharEdicaoProduto(i)),
                                  style: {"border-radius":"8px","width":"fit-content","height":"fit-content","cursor":"pointer"},
                                  class: "p-2 bg-danger me-1"
                                }, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass({'objeto-girando': _ctx.carregandoModelos[i]})
                                  }, _hoisted_39, 2)
                                ], 8, _hoisted_37))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", {
                              onClick: ($event: any) => (_ctx.removeProduto(i)),
                              style: {"border-radius":"8px","width":"fit-content","height":"fit-content","cursor":"pointer"},
                              class: "p-2 bg-danger ms-1"
                            }, _hoisted_42, 8, _hoisted_40)
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ]),
                _createElementVNode("section", null, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.adicionaProduto())),
                    style: {"height":"fit-content","white-space":"nowrap"},
                    class: "btn btn-danger d-flex flex-row gap-3 px-5 py-3 justify-content-center align-items-center m-0 texto"
                  }, [
                    _hoisted_43,
                    _createTextVNode(" Adicionar ")
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_44, [
              false
                ? (_openBlock(), _createElementBlock("label", _hoisted_45, _toDisplayString('')))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (!_ctx.loadingSalva && _ctx.copiarProdutos())),
                style: {"height":"fit-content","white-space":"nowrap"},
                class: "btn btn-danger d-flex d-inline-block text-truncate flex-row justify-content-center align-items-center px-5 py-3 gap-3 m-0 texto"
              }, [
                _hoisted_46,
                _createTextVNode(" Copiar ")
              ]),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (!_ctx.loadingSalva && _ctx.colarProdutos())),
                style: _normalizeStyle([{"height":"fit-content","white-space":"nowrap"}, `opacity: ${ _ctx.produtoCopiado.length > 0 ? 1 : 0.3}`]),
                class: "btn btn-danger d-flex d-inline-block text-truncate flex-row justify-content-center align-items-center px-5 py-3 gap-3 m-0 texto"
              }, [
                _hoisted_47,
                _createTextVNode(" Colar ")
              ], 4),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (!_ctx.loadingSalva && _ctx.salvaModificacao())),
                style: {"height":"fit-content","white-space":"nowrap","margin-left":"auto !important"},
                class: "btn btn-danger d-flex flex-row gap-3 px-5 py-3 justify-content-center align-items-center m-0 texto"
              }, [
                (_ctx.loadingSalva)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, _hoisted_50))
                  : (_openBlock(), _createElementBlock("svg", _hoisted_51, _hoisted_53)),
                _createTextVNode(" Salvar ")
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_modal_info_veiculo, {
      fechaModal: _ctx.fechaModalInfoVeiculo,
      "target-click-car": _ctx.veiculos[0]
    }, null, 8, ["fechaModal", "target-click-car"])
  ], 64))
}